import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import laptopImg from "../../Assets/about.png";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaDiscord, FaFacebook, FaLinkedinIn } from "react-icons/fa";
import {BsTelegram, BsWhatsapp } from "react-icons/bs";
import AboutCard from "./AboutCard";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
         
            <Card className="quote-card-view">
               <Card.Body>   
                  <blockquote className="blockquote mb-0">
                        <p style={{ textAlign: "justify" }} className="home-about-body">
                        Hi, I am <span className="purple">Yonas Fsaha </span>a webapp technology engineer with 3 <br/>
                        years of experience in building and maintaining <span className="purple">high-traffic</span><br/>
                        websites and web applications.
                        <br/>
                        <br/>
                         Passionate about creating <span className="purple">user-friendly,visually appealing </span> and <br/>
                         <span className="purple">high-performing</span> websites that meet the needs of my clients.
                            <br/>
                            <br/>
                            I'm always up to date on the latest technologies. and I<br/>
                             love working with clients to bring their visions to life. 
                           
                                
                          </p>
                  </blockquote>
               </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
          
{/* thrd part start */}
          <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
           >
            <AboutCard />
          </Col>  
        </Row>

  {/* thrd part end */}
        <Row>
          <Col md={12} className="home-about-social">
            <h1>You can <span className="purple">find me</span> on</h1>
            
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/yonas-fsaha"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/yonas-fsaha"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/jonahfsaha/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://t.me/C404der"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <BsTelegram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <BsWhatsapp />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/lij.yona.1"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaDiscord />
                </a>
              </li>
             
            </ul>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
